import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer 
      className="site-footer text-light pt-5 pb-3 position-relative"
      style={{
        backgroundImage: `url('/images/lotos-wealth-bg2.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Dark overlay with higher opacity to make text pop clearly */}
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-black" style={{ opacity: '0.75', zIndex: 0 }}></div>

      <div className="container py-4 position-relative" style={{ zIndex: 1 }}>
        <div className="row g-4">
          
          {/* Column 1: Brand Info & Contact */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <div className="mb-4">
              <NavLink to="/" className="d-inline-block">
                <img src="/images/lotoswealth-logo.png" alt="Lotoswealth Logo" width={250}   className="mb-3" />
              </NavLink>
              <p className="text-light small opacity-75" style={{ lineHeight: '1.8' }}>
                Your trusted financial partner for holistic wealth management, proactive investment planning, and secure asset preservation strategies.
              </p>
            </div>
            
            <div className="contact-info small text-light">
              <p className="mb-2 d-flex align-items-center opacity-75">
                <FaMapMarkerAlt className="text-warning me-2 flex-shrink-0" />
                <span>Hyderabad, Telangana, India</span>
              </p>
              <p className="mb-2 d-flex align-items-center opacity-75">
                <FaPhoneAlt className="text-warning me-2 flex-shrink-0" />
                <span>+91 889 786 6074</span>
              </p>
              <p className="mb-0 d-flex align-items-center opacity-75">
                <FaEnvelope className="text-warning me-2 flex-shrink-0" />
                <span>info@lotoswealth.com</span>
              </p>
            </div>
          </div>

          {/* Column 2: Wealth Management Services */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h5 className="text-white fw-bold fs-6 mb-3 text-uppercase tracking-wider border-start border-warning border-3 ps-2">
              Wealth Management
            </h5>
            <ul className="list-unstyled small footer-links">
              <li className="mb-2"><NavLink to="/wealth-management" className="text-light text-opacity-75 text-decoration-none hover-white">Wealth Management</NavLink></li>
              <li className="mb-2"><NavLink to="/portfolio-management-services" className="text-light text-opacity-75 text-decoration-none hover-white">Portfolio Management Services</NavLink></li>
              <li className="mb-2"><NavLink to="/tax-planning" className="text-light text-opacity-75 text-decoration-none hover-white">Tax Planning</NavLink></li>
              <li className="mb-2"><NavLink to="/offshore-products" className="text-light text-opacity-75 text-decoration-none hover-white">Offshore Products</NavLink></li>
              <li className="mb-2"><NavLink to="/estate-planning" className="text-light text-opacity-75 text-decoration-none hover-white">Estate Planning</NavLink></li>
              <li className="mb-2"><NavLink to="/alternate-investments" className="text-light text-opacity-75 text-decoration-none hover-white">Alternate Investments</NavLink></li>
              <li className="mb-2"><NavLink to="/private-equity" className="text-light text-opacity-75 text-decoration-none hover-white">Private Equity</NavLink></li>
              <li className="mb-0"><NavLink to="/private-credit" className="text-light text-opacity-75 text-decoration-none hover-white">Private Credit</NavLink></li>
            </ul>
          </div>

          {/* Column 3: Investment & Financial Planning */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h5 className="text-white fw-bold fs-6 mb-3 text-uppercase tracking-wider border-start border-warning border-3 ps-2">
              Investment Planning
            </h5>
            <ul className="list-unstyled small footer-links">
              <li className="mb-2"><NavLink to="/financial-planning" className="text-light text-opacity-75 text-decoration-none hover-white">Financial Planning</NavLink></li>
              <li className="mb-2"><NavLink to="/goal-based-investments" className="text-light text-opacity-75 text-decoration-none hover-white">Goal Based Investments</NavLink></li>
              <li className="mb-2"><NavLink to="/retirement-planning" className="text-light text-opacity-75 text-decoration-none hover-white">Retirement Planning</NavLink></li>
              <li className="mb-2"><NavLink to="/post-retirement-solutions" className="text-light text-opacity-75 text-decoration-none hover-white">Post Retirement Solutions</NavLink></li>
              <li className="mb-2"><NavLink to="/fire-planning" className="text-light text-opacity-75 text-decoration-none hover-white">FIRE Planning</NavLink></li>
              <li className="mb-2"><NavLink to="/corporate-financial-wellness" className="text-light text-opacity-75 text-decoration-none hover-white">Corporate Financial Wellness</NavLink></li>
              <li className="mb-2"><NavLink to="/asset-management" className="text-light text-opacity-75 text-decoration-none hover-white">Asset Management</NavLink></li>
              <li className="mb-0"><NavLink to="/stock-investment" className="text-light text-opacity-75 text-decoration-none hover-white">Stocks Investment</NavLink></li>
            </ul>
          </div>

          {/* Column 4: Quick Links, Loans & Resources */}
          <div className="col-lg-3 col-md-6">
            <h5 className="text-white fw-bold fs-6 mb-3 text-uppercase tracking-wider border-start border-warning border-3 ps-2">
              Quick Links & Loans
            </h5>
            <ul className="list-unstyled small footer-links mb-3">
              <li className="mb-2"><NavLink to="/" className="text-light text-opacity-75 text-decoration-none hover-white">Home</NavLink></li>
              <li className="mb-2"><NavLink to="/about-us" className="text-light text-opacity-75 text-decoration-none hover-white">About Us</NavLink></li>
              <li className="mb-2"><NavLink to="/mutual-funds-investment" className="text-light text-opacity-75 text-decoration-none hover-white">Mutual Funds Investment</NavLink></li>
              <li className="mb-2"><NavLink to="/home-loan" className="text-light text-opacity-75 text-decoration-none hover-white">Home Loan</NavLink></li>
              <li className="mb-2"><NavLink to="/car-loan" className="text-light text-opacity-75 text-decoration-none hover-white">Car Loan</NavLink></li>
              <li className="mb-2"><NavLink to="/education-loan" className="text-light text-opacity-75 text-decoration-none hover-white">Education Loan</NavLink></li>
              <li className="mb-2"><NavLink to="/articles" className="text-light text-opacity-75 text-decoration-none hover-white">Resources & Articles</NavLink></li>
              <li className="mb-0"><NavLink to="/contact-us" className="text-light text-opacity-75 text-decoration-none hover-white">Contact Us</NavLink></li>
            </ul>

            <div className="social-icons d-flex gap-2 mt-4">
              <a href="#facebook" className="social-btn d-flex align-items-center justify-content-center rounded-circle bg-light text-dark opacity-75" style={{ width: '32px', height: '32px' }}><FaFacebookF size={12} /></a>
              <a href="#twitter" className="social-btn d-flex align-items-center justify-content-center rounded-circle bg-light text-dark opacity-75" style={{ width: '32px', height: '32px' }}><FaTwitter size={12} /></a>
              <a href="#linkedin" className="social-btn d-flex align-items-center justify-content-center rounded-circle bg-light text-dark opacity-75" style={{ width: '32px', height: '32px' }}><FaLinkedinIn size={12} /></a>
              <a href="#instagram" className="social-btn d-flex align-items-center justify-content-center rounded-circle bg-light text-dark opacity-75" style={{ width: '32px', height: '32px' }}><FaInstagram size={12} /></a>
            </div>
          </div>

        </div>

        {/* Bottom Copyright Bar */}
        <hr className="border-light my-4 opacity-25" />
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start text-light small opacity-75">
            <p className="mb-0">&copy; {new Date().getFullYear()} Lotos Wealth. All Rights Reserved.</p>
          </div>
          <div className="col-md-6 text-center text-md-end text-light small mt-2 mt-md-0">
            <a href="/privacy-policy" className="text-light text-opacity-75 text-decoration-none me-3">Privacy Policy</a> | &nbsp;
            <a href="/terms-of-service" className="text-light text-opacity-75 text-decoration-none">Terms of Service</a> &nbsp; | &nbsp;
            <a href="/refund-and-cancellation-policy" className="text-light text-opacity-75 text-decoration-none">Refund and Cancellation Policy</a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;